import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface, Validator } from "class-validator";
import { CustomCommonValidator } from './customCommonValidator'
@ValidatorConstraint()
export class BrandsFieldValidator extends CustomCommonValidator implements ValidatorConstraintInterface {

	validate(dynamicProperties: any, validationArguments: ValidationArguments) {
		let properties: string[] = Object.getOwnPropertyNames(dynamicProperties);
		let result: boolean = true;
		const validator = this.getValidator();
		this.message = "";

		if (properties.find(p => p == "email") != null) {
			let email: any = dynamicProperties['email'] as string;
			if (email && !validator.isEmail(email)) {
				this.message = this.message.concat("Email must be a valid email<br />");
				result = false;
			}
		}
		if (properties.find(p => p == "phone") != null) {
			let phone: any = dynamicProperties["phone"] as string;

			if (phone && !validator.matches(phone, /\(?\d+\)?[-.\s]?\d+[-.\s]?\d+$/)) {
				result = false;
				this.message = this.message.concat("Phone is not a phone number<br />");
			}
		}
		if (properties.find(p => p == "quoteNumberPrefix") != null) {
			let quoteNumberPrefix: any = dynamicProperties["quoteNumberPrefix"] as string;

			if ( !validator.isDefined(quoteNumberPrefix)) {
				result = false;
				this.message = this.message.concat("Prefix is required<br />");
			}
		}
		return result;
	}

	defaultMessage(args: ValidationArguments) { // here you can provide default error message if validation failed
		return this.message;
	}
}



// WEBPACK FOOTER //
// ./src/core/customValidator/brandFieldsValidator.ts